import notifee, { EventType, Notification as Notifee } from '@notifee/react-native';

const channelId = `default`;
export const initializeNotifee = async () => {
  const createChannel = await notifee.createChannel({
    id: channelId,
    name: 'Ninja kisan Generic',
  });
};

export const displayLocalPush = async (payload: Notifee) => {
  try {
    await initializeNotifee();
    if (!payload.android) {
      payload.android = {
        channelId,
        smallIcon: 'ic_launcher_round',
      };
    }
    await notifee.displayNotification(payload);
  } catch (error) {
    console.log('error useNotification *****', error);
  }
};
